module.exports = __webpack_public_path__ + "img/7.95a6d612.svg";